import {applyMiddleware, compose, createStore} from "redux";
import {reducers} from "../reducers";
import thunk from "redux-thunk";

export const Store = createStore(reducers, compose(applyMiddleware(thunk)));
///store dispatch
